export default [
  {
    path: 'inquiry',
    name: 'inquiry.artist.create',
    component: () => import('@pages/inquiry/Index'),
    props: true
  },
]
